import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicos',
  templateUrl: './servicos.component.html'
})
export class ServicosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
